import { render } from "./InlineDropdownItem.vue?vue&type=template&id=436b2284&scoped=true&ts=true&lang=pug"
import script from "./InlineDropdownItem.vue?vue&type=script&lang=ts"
export * from "./InlineDropdownItem.vue?vue&type=script&lang=ts"

import "./InlineDropdownItem.vue?vue&type=style&index=0&id=436b2284&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436b2284"]])

export default __exports__